module.exports = __webpack_public_path__ + "cd3fb7e380edfb81973fd62a1a71e5b2.MP3";